import getToken from 'utils/getToken';

const { locale } = getToken();

export const isUk = () => locale === 'en-gb';
export const isANZ = () => locale === 'en-au' || locale === 'en-nz';
